export const selectDrm =
  (addToCart: (drm?: string) => void) => async (value: string | number) => {
    await addToCart(String(value));
  };
